module.exports = "/_next/static/images/about-counter-1-1-0c1b036046b403d420b59b509534a01b.jpg";